<template>
<!-- 包裹列表页面 -->
  <div>
    <div class="commonFilter">
      <div class="card-container">
        <div class="card-content">
          <Form ref="pageParams" :model="pageParams" :label-width="100" label-position="right">
            <div class="platformSearch" style="margin-top:16px;">
              <Row>
                <Col span="5">
                  <Form-item :label="$t('logisticsProvider.country') + '：'" prop="countryList ">
                    <Select filterable multiple v-model="pageParams.countryCodeList">
                      <Option v-for="(item, index) in countryList" :key="index" :value='item.twoCode'>{{item.cnName}}</Option>
                    </Select>
                  </Form-item>
                </Col>
                <Col span="6" push="1">
                  <Form-item :label="$t('logisticsProvider.channelName') + '：'" prop="channelNameList ">
                    <Select v-model="pageParams.shippingMethodId" clearable filterable>
                      <Option v-for="(item, index) in channelNameList" :key="index" :value='item.shippingMethodId'>{{item.shippingMethodName}}</Option>
                    </Select>
                  </Form-item>
                </Col>
              </Row>
              <Row>
                <Col span="5">
                  <Form-item :label="$t('common.deliveryDate') + '：'" prop="deliveryDate ">
                    <Date-picker :value="deliveryDate" :clearable="clearAble" :options="options2" type="daterange" placement="bottom-end" :placeholder="$t('common.selectDate')"  @on-clear="resetDate" @on-change="getDateValue" style="width:237px"></Date-picker>
                  </Form-item>
                </Col>
                <Col span="6" push="1">
                  <Form-item :label="$t('logisticsProvider.logisticsTrackNum') + '：'" prop="deliveryDate ">
                    <Input v-model.trim="pageParams.trackingNumber"></Input>
                  </Form-item>
                </Col>
                <Col span="2" push="2">
                  <Button type="primary" @click="search" v-once icon="search">{{$t('common.search')}}</Button>
                </Col>
              </Row>
            </div>
          </Form>
        </div>
      </div>
    </div>
    <!-- 包裹信息 -->
    <div class="orderTable normalTop">
      <Table highlight-row border :height="tableHeight" :columns="logisticsColumn" :data="logisticsData"></Table>
      <div class="table-page">
        <div class="table-page-right">
          <Page :total="total" @on-change="changePage" show-total :page-size="pageParams.pageSize" show-elevator :current="pageParams.pageNum" show-sizer @on-page-size-change="changePageSize" placement="top" :page-size-opts="pageArray"></Page>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
import tableMixin from '@/components/mixin/table_mixin';
export default {
  mixins: [ Mixin, tableMixin ],
  data () {
    let self = this;
    return {
      pageParamsStatus: false, // 是否重新加载货品列表数据
      pageParams: {
        merchantId: '', // 商户编号
        partnerId: '', // 合作伙伴编号
        countryCodeList: [], // 国家id
        shippingMethodId: '', // 物流渠道id
        startTime: '', // 开始时间
        endTime: '', // 结束时间
        trackingNumber: '', // 物流跟踪号
        pageSize: 10,
        pageNum: 1,
        startPos: 0
      },
      options2: {
        shortcuts: [
          {
            text: self.t('common.lastWeek'),
            value: function () {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            }
          },
          {
            text: self.t('common.lastMonth'),
            value: function () {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            }
          },
          {
            text: self.t('common.last3months'),
            value: function () {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            }
          }
        ]
      },
      channelNameList: [],
      countryList: [], // 国家
      deliveryDate: [], // 发货日期
      clearAble: true,
      logisticsColumn: [
        {
          title: self.t('common.serialNum'),
          type: 'index',
          width: 70,
          fixed: 'left',
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.packageNums'),
          key: 'referId',
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.logisticsTrackNum'),
          key: 'trackingNumber',
          align: 'center'
        },
        {
          title: self.t('common.merchantId'),
          key: 'merchantId',
          align: 'center'
        },
        {
          title: self.t('common.companyName'),
          key: 'companyName',
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.country'),
          key: 'countryName',
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.weight'),
          key: 'packageWeight',
          align: 'center',
          render: (h, params) => {
            if (params.row.packageWeight === '') {
              return '0.0';
            } else {
              return h('span', params.row.packageWeight);
            }
          }
        },
        {
          title: self.t('logisticsProvider.cost'),
          key: 'packageCost',
          align: 'center',
          render: (h, params) => {
            if (params.row.packageCost === '') {
              return '0.00';
            } else {
              return h('span', params.row.packageCost);
            }
          }
        },
        {
          title: self.t('logisticsProvider.channelName'),
          key: 'shippingMethodName',
          align: 'center'
        },
        {
          title: self.t('common.deliveryDate'),
          key: 'sendDateErp',
          align: 'center',
          render: (h, params) => {
            if (params.row.sendDateErp) {
              return h('span', self.setTimeData(params.row.sendDateErp));
            }
          }
        }
      ],
      logisticsData: [],
      total: 0
    };
  },
  methods: {
    search () { // 查询
      let v = this;
      v.pageParamsStatus = true;
      v.pageParams.pageNum = 1;
    },
    // 补0操作
    getZeroFn (num) {
      if (parseInt(num) < 10) {
        num = '0' + num;
      }
      return num;
    },
    // 格式化日期格式
    setTimeData (str) {
      // debugger;
      let v = this;
      let oDate = new Date(parseInt(str));
      let oYear = oDate.getFullYear(); // 年
      let oMonth = oDate.getMonth() + 1; // 月
      let oDay = oDate.getDate(); // 日
      let oHour = oDate.getHours(); // 时
      let oMin = oDate.getMinutes(); // 分
      let oSen = oDate.getSeconds(); // 秒
      let oTime = oYear + '-' + v.getZeroFn(oMonth) + '-' + v.getZeroFn(oDay) + ' ' + v.getZeroFn(oHour) + ':' + v.getZeroFn(oMin) + ':' + v.getZeroFn(oSen); // 最后拼接时间
      return oTime;
    },
    resetDate () {
      let v = this;
      v.pageParams.startTime = null;
      v.pageParams.endTime = null;
    },
    // 获取日期返回值
    getDateValue (value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(v.t('validValue.errorDate'));
        v.resetDate();
      } else {
        if (value[0] === '' || value[0] === null) return false;
        let startTime = v.getUniversalTime(new Date(value[0]).getTime(), 'fulltime');
        let endTime = v.getUniversalTime(new Date(value[1]).getTime(), 'fulltime');
        v.pageParams.startTime = startTime.substring(0, 10);
        v.pageParams.endTime = endTime.substring(0, 10);
      }
    },
    // 获取国家列表
    getCountryList () {
      let v = this;
      let pos = [];
      v.axios.get(api.get_countrys)
        .then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            data.forEach((n, i) => {
              pos.push({
                cnName: n.cnName,
                twoCode: n.twoCode
              });
            });
            v.countryList = pos;
          } else {
            v.showErrorInfoFn(response.data.code, response.data.message); // 错误提示方法
          }
        });
    },
    // 表格数据
    getList () {
      let v = this;
      v.axios.post(api.get_packageList, v.pageParams)
        .then(res => {
          if (res.data.code === 0) {
            v.logisticsData = res.data.datas.list;
            v.total = res.data.datas.total;
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    // 获取渠道名称
    getChannelName () {
      let v = this;
      let pos = [];
      v.axios.post(api.get_shipMethod)
        .then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            data.forEach((n, i) => {
              pos.push({
                shippingMethodName: n.shippingMethodName,
                shippingMethodId: n.shippingMethodId
              });
            });
            v.channelNameList = pos;
          } else {
            v.showErrorInfoFn(response.data.code, response.data.message); // 错误提示方法
          }
        });
    }
  },
  created () {
    this.tableHeight = this.getTableHeight(452);
    this.getCountryList();
    let value = (function () {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      return [start, end];
    })();
    this.deliveryDate = value;
    this.getDateValue(value);
    this.getList();
    this.getChannelName();
  },
  watch: {
    pageParamsStatus (n, o) { // 监听重置列表数据
      let v = this;
      if (n) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/logisticsProvider/components/logisticsProvider/parcelManagement.vue